import config from './config';
import { CreateUUID } from './utils/helper';
import SessionDB from './utils/sessionStorage';
import { getActiveShopId } from './utils/shopSession';

const BASE_API = `${config.BASE_API}/api`;

export const BASE_API_URL = BASE_API;


export const FAKE_STORE_API = 'https://fakestoreapi.com';


export const V1_API = `${BASE_API}/v1`;
export const CURRENT_API = V1_API;

export const API_ENDPOINTS = {
  auth: {
    LOGIN: `${CURRENT_API}/auth/login`,
    FORGOT_PASSWORD: `${CURRENT_API}/auth/forgot-password`,
    REFRESH_TOKEN: `${CURRENT_API}/auth/refresh`,
    LOGOUT: `${CURRENT_API}/auth/logout`,
    ME: `${CURRENT_API}/auth/me`,
  },
  setup: {
    STATUS: `${CURRENT_API}/setup/status`,
    CREATE: `${CURRENT_API}/setup`,
  },
  shops: {
    LIST: `${CURRENT_API}/shops`,
    CREATE: `${CURRENT_API}/shops`,
    UPDATE: (id: number | string) => `${CURRENT_API}/shops/${id}`,
  },
  test: {
    DUMMY_API: `/test`,
    PUBLIC_TEST_API: 'https://jsonplaceholder.typicode.com/todos/1',
  },
  products: {
    LIST: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/products`,
    CREATE: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/products`,
    GET: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/products/${id}`,
    UPDATE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/products/${id}`,
    DELETE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/products/${id}`,
    STOCK: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/products/${id}/stock`,
    WASTAGE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/products/${id}/wastage`,
  },
  services: {
    LIST: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/services`,
    CREATE: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/services`,
    GET: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/services/${id}`,
    UPDATE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/services/${id}`,
    DELETE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/services/${id}`,
  },
  printMaterials: {
    LIST: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/print-materials`,
    CREATE: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/print-materials`,
    GET: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/print-materials/${id}`,
    UPDATE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/print-materials/${id}`,
    DELETE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/print-materials/${id}`,
    STOCK: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/print-materials/${id}/stock`,
    WASTAGE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/print-materials/${id}/wastage`,
  },
  customers: {
    LIST: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/customers`,
    CREATE: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/customers`,
    GET: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/customers/${id}`,
    UPDATE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/customers/${id}`,
    DELETE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/customers/${id}`,
    COLLECT: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/customers/${id}/collect`,
    STATEMENT: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/customers/${id}/statement`,
  },
  vendors: {
    LIST: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/vendors`,
    CREATE: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/vendors`,
    GET: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/vendors/${id}`,
    UPDATE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/vendors/${id}`,
    DELETE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/vendors/${id}`,
    ADVANCE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/vendors/${id}/advance`,
    REFUND: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/vendors/${id}/refund`,
    STATEMENT: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/vendors/${id}/statement`,
  },
  purchases: {
    LIST: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/purchases`,
    CREATE: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/purchases`,
    GET: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/purchases/${id}`,
    PAY: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/purchases/${id}/pay`,
    DELETE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/purchases/${id}`,
  },
  expenses: {
    LIST: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/expenses`,
    CREATE: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/expenses`,
    UPDATE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/expenses/${id}`,
    DELETE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/expenses/${id}`,
  },
  paymentMethods: {
    LIST: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/payment-methods`,
    CREATE: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/payment-methods`,
    GET: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/payment-methods/${id}`,
    UPDATE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/payment-methods/${id}`,
    DELETE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/payment-methods/${id}`,
  },
  transfers: {
    LIST: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/fund-transfers`,
    CREATE: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/fund-transfers`,
  },
  balances: {
    ACCOUNT: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/reports/balances`,
  },
  sales: {
    LIST: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/sales`,
    CREATE: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/sales`,
    GET: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/sales/${id}`,
    DELETE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/sales/${id}`,
  },
  credits: {
    LIST: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/credits`,
    GET: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/credits/${id}`,
    SETTLE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/credits/${id}/settle`,
  },
  dueCollections: {
    LIST: (shopId: number | string) =>
      `${CURRENT_API}/shops/${shopId}/due-collections`,
  },
  staff: {
    LIST: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/staff`,
    CREATE: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/staff`,
    UPDATE: (shopId: number | string, userId: number | string) =>
      `${CURRENT_API}/shops/${shopId}/staff/${userId}`,
    DELETE: (shopId: number | string, userId: number | string) =>
      `${CURRENT_API}/shops/${shopId}/staff/${userId}`,
    RESET_PASSWORD: (shopId: number | string, userId: number | string) =>
      `${CURRENT_API}/shops/${shopId}/staff/${userId}/reset-password`,
  },
  tasks: {
    LIST: (shopId: number | string, stage?: string) =>
      `${CURRENT_API}/shops/${shopId}/tasks${stage ? `?stage=${stage}` : ''}`,
    CREATE: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/tasks`,
    GET: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/tasks/${id}`,
    UPDATE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/tasks/${id}`,
    NOTES: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/tasks/${id}/notes`,
    HOURS: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/tasks/${id}/hours`,
    TRANSITION: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/tasks/${id}/transition`,
    TIMELINE: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/tasks/${id}/timeline`,
    SUMMARY: (shopId: number | string) => `${CURRENT_API}/shops/${shopId}/tasks-summary`,
  },
  activity: {
    FEED: (shopId: number | string, limit = 30) =>
      `${CURRENT_API}/shops/${shopId}/activity?limit=${limit}`,
    NOTIFICATIONS: (shopId: number | string, limit = 30, offset = 0) =>
      `${CURRENT_API}/shops/${shopId}/notifications?limit=${limit}&offset=${offset}`,
    UNREAD_COUNT: (shopId: number | string) =>
      `${CURRENT_API}/shops/${shopId}/notifications/unread-count`,
    MARK_READ: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/notifications/${id}/read`,
    READ_ALL: (shopId: number | string) =>
      `${CURRENT_API}/shops/${shopId}/notifications/read-all`,
  },
  reports: {
    SUMMARY: (shopId: number | string, from: string, to: string) =>
      `${CURRENT_API}/shops/${shopId}/reports/summary?from=${from}&to=${to}`,
    DAYBOOK: (shopId: number | string, date: string) =>
      `${CURRENT_API}/shops/${shopId}/reports/daybook?date=${date}`,
    METHOD_HISTORY: (shopId: number | string, name: string, from: string, to: string) =>
      `${CURRENT_API}/shops/${shopId}/reports/methods/${encodeURIComponent(name)}/history?from=${from}&to=${to}`,
    IMPORT_PREVIEW: (shopId: number | string) =>
      `${CURRENT_API}/shops/${shopId}/reports/imports/preview`,
    IMPORTS: (shopId: number | string) =>
      `${CURRENT_API}/shops/${shopId}/reports/imports`,
    IMPORT: (shopId: number | string, id: number | string) =>
      `${CURRENT_API}/shops/${shopId}/reports/imports/${id}`,
  },
} as const;

// Provide a camelCase alias to match older `APIEndPoints` export
export const APIEndPoints = API_ENDPOINTS;

export const DEFAULT_AVATAR = 'https://randomuser.me/api/portraits/men/32.jpg';

type Token = string | null;

export const APIHeaders = {
  Accept: 'application/json',
  'Content-Type': 'application/json',
  'Debug-Id': CreateUUID().replace(/-/g, ''),
};

export const APIHeadersForMultipartFormData = {
  Accept: 'application/json',
  'Debug-Id': CreateUUID().replace(/-/g, ''),
};

export const APIHeadersWithAuth = (token?: Token) => {
  const t = token || SessionDB.getAccessToken();
  const headers: Record<string, string> = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'Debug-Id': CreateUUID().replace(/-/g, ''),
  };
  if (t) headers.Authorization = `Bearer ${t}`;
  const shopId = getActiveShopId();
  if (shopId) headers['X-Shop-Id'] = String(shopId);
  return headers;
};




export default API_ENDPOINTS;
